import Flag from 'react-world-flags';
import country from 'country-list-js';

export const COUNTRY_NAMES = country.ls('name');
export const COUNTRY_CODES = COUNTRY_NAMES.sort().map(e => country.findByName(e).code.iso2);
export const COUNTRY_CODES_ISO3 = COUNTRY_NAMES.sort().map(e => country.findByName(e).code.iso3);
export const COUNTRY_REGIONS = COUNTRY_NAMES.sort().map(e => country.findByName(e).continent);
export const COUNTRY_CAPITALS = COUNTRY_NAMES.sort().map(e => country.findByName(e).capital);
export const COUNTRY_CURRENCIES = COUNTRY_NAMES.sort().map(e => country.findByName(e).currency.code);
export const COUNTRY_FLAGS = COUNTRY_CODES.map(e => 
    <Flag code={e} title={'title'}></Flag>);
const cc = require('currency-codes');

export const COUNTRY_INFO = Object.values(COUNTRY_NAMES.reduce((acc, key, index) => {
    
    COUNTRY_CURRENCIES[20] = 'BYN';
    COUNTRY_CURRENCIES[53] = 'EUR';
    COUNTRY_CURRENCIES[127] = 'EUR';
    COUNTRY_CURRENCIES[139] = 'MRU';
    COUNTRY_CURRENCIES[194] = 'STN';
    COUNTRY_CURRENCIES[199] = 'SLE';
    COUNTRY_CURRENCIES[243] = 'VES';
    COUNTRY_CURRENCIES[248] = 'ZMW';
    COUNTRY_CURRENCIES[249] = 'ZWG';
    COUNTRY_NAMES[215] = 'Eswatini';
    COUNTRY_CAPITALS[27] = 'Kralendijk, Oranjestad, The Bottom';
    COUNTRY_CAPITALS[30] = 'No capital';
    COUNTRY_CAPITALS[55] = 'Willemstad';
    COUNTRY_CAPITALS[96] = 'No capital';
    COUNTRY_CAPITALS[200] = 'Singapore';
    COUNTRY_CAPITALS[224] = 'No capital';

    return {
        ...acc, 
        [key]: {
            name: COUNTRY_NAMES[index],
            iso2: COUNTRY_CODES[index],
            iso3: COUNTRY_CODES_ISO3[index],
            flag: <Flag 
                code={COUNTRY_CODES[index]} 
                title={COUNTRY_NAMES[index]}></Flag>,
            region: COUNTRY_REGIONS[index] || 'Unknown',
            capital: COUNTRY_CAPITALS[index] || 'No capital',
            currency: cc.code(COUNTRY_CURRENCIES[index])?.currency || COUNTRY_CURRENCIES[index],
            other: '',
            wish: false,
            visited: false,
            wish_priority: null,
            visited_status: null,
            index: index
        }
    }},{})); // make new obj from arrays

// updates to country names or specific names
//COUNTRY_INFO[215].name = 'Eswatini';
COUNTRY_INFO[215].other = 'Swaziland';
COUNTRY_INFO[235].other = 'UAE';
COUNTRY_INFO[228].other = 'Türkiye';
COUNTRY_INFO[206].other = 'RSA';
COUNTRY_INFO[236].other = 'England Scotland Wales Northen Ireland The Great Britan UK';
delete COUNTRY_INFO[8]
delete COUNTRY_INFO[238]

// taken from here: https://www.npmjs.com/package/country-list-js
// and flags from here https://github.com/smucode/react-world-flags
